import type { ComponentProps, ElementRef, PropsWithChildren } from "react";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const Input = forwardRef<
  ElementRef<"div">,
  ComponentProps<"div"> & PropsWithChildren
>(({ className, children, ...props }, ref) => {
  return (
    <div
      className={twMerge("flex justify-between", className)}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  );
});
Input.displayName = "PersonalInformation.Input";

type ContentTitleProps = ComponentProps<"p"> & PropsWithChildren;
export const ContentTitle = forwardRef<ElementRef<"p">, ContentTitleProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <p
        className={twMerge(
          `p-2 text-lg text-neutral-700 dark:text-neutral-variant-90`,
          className,
        )}
        ref={ref}
        {...rest}
      >
        {children}
      </p>
    );
  },
);
ContentTitle.displayName = "PersonalInformation.ContentTitle";

type ContentProps = ComponentProps<"p"> & PropsWithChildren;

export const Content = forwardRef<ElementRef<"p">, ContentProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <p className={twMerge(`p-2 text-lg`, className)} ref={ref} {...rest}>
        {children}
      </p>
    );
  },
);
Content.displayName = "PersonalInformation.Content";

type IconProps = {
  icon: string;
  size?: "large" | "medium" | "small";
} & ComponentProps<"div">;
export const Icon = forwardRef<ElementRef<"div">, IconProps>(
  ({ className, icon, size = "medium", ...props }, ref) => {
    let sizeClass = "p-4 text-4xl w-16 h-16";
    if (size === "small") sizeClass = "p-2 text-xs w-7 h-7";
    if (size === "large") sizeClass = "p-6 text-6xl w-24 h-24";
    return (
      <div
        className={twMerge(`flex justify-center rounded-full`, className)}
        ref={ref}
        {...props}
      >
        <div
          className={`flex items-center justify-center rounded-full bg-surface-container-highest text-white dark:bg-surface-container-high-dark ${sizeClass}`}
        >
          <p className="m-0">{icon}</p>
        </div>
      </div>
    );
  },
);
Icon.displayName = "PersonalInformation.Icon";
